<template>
  <div class="section" >
      <div class="main">
        <ul>
          <li class="list_item" v-for="(item,index) in lists" :key="index">
            <p class="title">{{item.title}}</p>
            <p class="content">{{item.content}}</p>
            <p class="last">{{item.last}}</p>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
export default {
  name:"newFour",
  data(){
    return{
      lists:[
        {title:'后台管理系统',content:'免费后台管理系统、代理、商家、子账号分管功能，轻松管理账目，多种财务报表，随时随地查看',last: '订单和机器运营的情况'},
        {title:'资金安全保障',content:'维码器与腾讯、支付宝、兴业银行、汇卡商务全面战略合作，维码器系统直接调用银行和腾讯、支付宝接口、多方对账实现零误差，100%保障资金安全',last: ''},
        {title:'消息推送功能',content:'订单支付，设备异常，订单异常，提现审核、礼品数量不足，消费者提交申诉等系统主动推送消息至', last: '商家微信、短信或网页中'},
        {title:'会员卡功能',content:'虚拟会员卡功能，帮助商家快速回笼资金，可设置',last: '充值优惠，吸引并留住客户'},
        {title:'自动分账功能',content:'系统将自动按比例分账配套子账号共同查账对账功',last: '能，轻松解决合伙人分账困难繁琐等问题'},
        {title:'公众号吸粉功能',content:'每个商家都可以设置关注公众号赠币等营销活动，',last: '服务号，订阅号均可'},
      ]
    }
  },
  methods:{
    soft11(){
      this.$router.push({path:'/software'});
      this.$store.state.d4 = '';
    }
  },
 watch:{
        '$route':function(to,from){
　　　　　　　　document.body.scrollTop = '0';
              document.documentElement.scrollTop = '0';
        }
},
}
</script>

<style scoped>
.section{
    width: 100%;
    height: 900px;
    background: url(../assets/blue-bg.png) no-repeat;
    background-size: 100% 100%;
    background-position: center;
}
ul,li{
  margin: 0;
  padding: 0;
  list-style: none;
}
.main {
  width: 1200px;
  height: 900px;
  overflow:hidden;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main>ul{
  margin-right: -30px;
  margin-top: -40px;
}
.list_item {
  width: 380px;
  height: 238px;
  float: left;
  margin-right: 30px;
  margin-top: 40px;
  background-color: #ffffff;
  padding: 0px 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.list_item .title {
  font-family: 微软雅黑;
  font-size: 20px;
	letter-spacing: -1px;
  color: #333333;
  font-weight: bold;
}
.list_item .content {
  width: 100%;
  font-family: 微软雅黑;
  font-size: 14px;
	line-height: 22px;
	letter-spacing: 0px;
  color: #333333;
  text-align: justify;
  margin-top: 34px;
  word-wrap:break-word;
}
.list_item .last {
  width: 100%;
  font-family: 微软雅黑;
  font-size: 14px;
	line-height: 22px;
	letter-spacing: 0px;
  color: #333333;
  text-align: center;
  word-wrap:break-word;
}
@media screen and (max-width: 1200px){
  .main{
      transform: scale(0.9);
  }
}
/* @media screen and (max-width: 1140px){
  .main{
      transform: scale(0.8);
  }
} */
</style>


// WEBPACK FOOTER //
// src/components/Three.vue